// src/redux/slices/Payments/paymentsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_BASE_URL, getAuthHeader } from '../../../services/api';

export const createCheckoutSession = createAsyncThunk(
  'payments/createCheckoutSession',
  async (bookingId, thunkAPI) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/payments/create-checkout-session`,
        { bookingId },
        { headers: getAuthHeader() }
      );
      return response.data.url;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const paymentsSlice = createSlice({
  name: 'payments',
  initialState: { isLoading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCheckoutSession.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createCheckoutSession.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createCheckoutSession.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default paymentsSlice.reducer;